import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';

export const selectApexState = (state: RootState) => state.apex;

export const selectApexAccounts = createSelector([selectApexState], (apex) => apex.accounts);

// Holdings for firm-data-blended custodian (Apex) accounts, keyed by
// custodian_account_id. See ApexState.custodianHoldingsById for why this is
// separate from selectApexAccounts.
export const selectCustodianHoldingsById = createSelector(
  [selectApexState],
  (apex) => apex.custodianHoldingsById,
);

// Transfers for the same accounts, keyed the same way. Separate from
// selectApexAccounts for the same reason as holdings above.
export const selectCustodianTransfersById = createSelector(
  [selectApexState],
  (apex) => apex.custodianTransfersById,
);

export const selectApexAssetMap = createSelector([selectApexState], (apex) => apex.assetMap);

export const selectApexUserInfo = createSelector([selectApexState], (apex) => apex.userInfo);

export const selectApexChartData = createSelector([selectApexState], (apex) => apex.chartData);

export const selectHoldingsFailedById = createSelector(
  [selectApexState],
  (apex) => apex.holdingsFailedById,
);
export const selectApexLoading = createSelector([selectApexState], (apex) => apex.loading);
